//Types
export const Types = {
  CREATE_PIPELINE_ACCESS: "CREATE_PIPELINE_ACCESS",
  UPDATE_PIPELINE_ACCESS: "UPDATE_PIPELINE_ACCESS",
  GET_PIPELINE_ACCESS: "GET_PIPELINE_ACCESS",
  GET_ALL_PIPELINES_ACCESS: "GET_ALL_PIPELINES_ACCESS",
  DELETE_PIPELINE_ACCESS: "DELETE_PIPELINE_ACCESS",
  SET_LOADING: "SET_LOADING",
  CLEAR_PIPELINES_ACCESS_REGISTER: "CLEAR_PIPELINES_ACCESSS_REGISTER",
  SAVE_PIPELINES_ACCESS_CREATION: "SAVE_PIPELINES_ACCESS_CREATION",
  
};

//Reducer
const initialState = {
  pipelinesAccess: null,
  pipelineAccess: null,
  loading: false,
};

const PipelinesAccess = (state = initialState, action) => {
  switch (action.type) {
    case Types.CREATE_PIPELINE_ACCESS:
      return {
        ...state,
      };

    case Types.UPDATE_PIPELINE_ACCESS:
      return {
        ...state,
        //pipeline: action.payload,
      };

    case Types.GET_PIPELINE_ACCESS:
      return {
        ...state,
        pipelineAccess: action.payload,
        loading: false,
      };

    case Types.GET_ALL_PIPELINES_ACCESS:
      return {
        ...state,
        pipelinesAccess: action.payload,
        loading: false,
      };

    case Types.DELETE_PIPELINE_ACCESS:
      return {
        ...state,
        pipelinesAccess: action.payload,
        loading: false,
      };

    case Types.CLEAR_PIPELINES_ACCESS_REGISTER:
      return initialState;

    case Types.SAVE_PIPELINES_ACCESS_CREATION:
      return {
        ...state,
        pipelinesAccess: action.payload,
      };

    case Types.SET_LOADING:
      return {
        ...state,
        loading: true,
      };


    default:
      return state;
  }
};

export default PipelinesAccess;
